import { Link } from 'react-router-dom';

import { SUPPORT_EMAIL } from '../lib/support';

/**
 * The public site's footer, in the home page's fixed dark palette on every
 * public page (TOM-980): the approved design's logo tile, wordmark and line,
 * and the site's links. The Support and Privacy policy links are the App
 * Store's Support and Privacy URLs (TOM-98, ADR 0280).
 */
export function SiteFooter() {
  return (
    <footer className="site-foot" id="contact">
      <div className="site-foot__inner">
        <div className="site-foot__brand">
          <Link to="/" className="site-foot__home">
            <span className="site-foot__tile">
              <img src="/logo.png" alt="" width={76} height={76} />
            </span>
            <span className="site-foot__name">Neomaris</span>
          </Link>
          <p className="site-foot__line">Your boat. Understood.</p>
        </div>
        <div className="site-foot__col">
          <h4>Product</h4>
          <Link to="/products">What Neomaris watches</Link>
          <Link to="/downloads">Download Core</Link>
          <Link to="/beta">Join the beta</Link>
          <Link to="/login">Sign in</Link>
        </div>
        <div className="site-foot__col">
          <h4>Company</h4>
          <Link to="/about">About</Link>
          <Link to="/support">Support</Link>
          <Link to="/status">Status</Link>
          <Link to="/contact">Contact us</Link>
          <Link to="/terms">Terms of service</Link>
          <Link to="/privacy">Privacy policy</Link>
        </div>
        <div className="site-foot__col">
          <h4>Get in touch</h4>
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </div>
      </div>
      <div className="site-foot__bottom">
        <p>&copy; 2026 Neomaris. All rights reserved.</p>
      </div>
    </footer>
  );
}
